import "./_vscode.scss"
const VsCode = ({gitHubEmbedLink}) => {
    return <><iframe allow="fullscreen" src={gitHubEmbedLink} title="description"></iframe></>
}

export default VsCode